export const constants = {
    NOTIFICATIONS_SOURCE: {
        UPDATE_ANN: 'UPDATE_ANN',
    },
    SUPPORT_EMAIL: 'support@toktokdoc.com',
    SUPPORT_PHONE: '01.88.32.84.91',
    HELP_CENTER_URL: 'https://aide.toktokdoc.com',
    NEWS_FEED_URL: 'https://aide.toktokdoc.com/s/topic/0TOIV00000055v74AA/fil-de-nouveautés',
}
